module.exports = __webpack_public_path__ + "img/laptop-apps.b49e6446.png";